import img from "../../../img/money.svg";
import img2 from "../../../img/moneyarm.svg";
import img3 from "../../../img/medical.svg";
import img4 from "../../../img/saving.svg";
import image from "../../../img/apple.svg";
import image2 from "../../../img/useryellow.svg";
import image3 from "../../../img/play.svg";
import image4 from "../../../img/userred.svg";

export const account = [
  {
    img: img,
    title: "My Balance",
    price: "$12,750",
    bg: "rgb(255, 245, 217)",
  },
  {
    img: img2,
    title: "Income",
    price: "$5,600",
    bg: "rgb(231, 237, 255)",
  },
  {
    img: img3,
    title: "Expense",
    price: "$3,460",
    bg: "rgb(255, 224, 235)",
  },
  {
    img: img4,
    title: "Total Saving",
    price: "$7,920",
    bg: "rgb(220, 250, 248)",
  },
];
export const debit = [
  {
    image: image,
    title: "Apple Store",
    date: "5h ago",
    price: "$450",
    bg: "rgb(220, 250, 248)",
  },
  {
    image: image2,
    title: "Michael",
    date: "2 days ago",
    price: "$160",
    bg: "rgb(255, 245, 217)",
  },
  {
    image: image3,
    title: "Playstation",
    date: "5 days ago",
    price: "$1085",
    bg: "rgb(231, 237, 255)",
  },
  {
    image: image4,
    title: "William",
    date: "10 days ago",
    price: "$90",
    bg: "rgb(255, 224, 235)",
  },
];
